import {Draft} from "@reduxjs/toolkit";
import {MainVideoState} from "../definitions/MainVideoState";

export function hasVideoEnded(state: Draft<MainVideoState>) {
    return state.currentFrame >= state.videoDurationInFrames - 1;
}
